import React from 'react'
import styled from 'styled-components'
import { Card } from 'react-mdl'

const cardStyle = { width: '98%', marginLeft: '1%', overflow: 'visible' }
const Content = styled.div`
  overflow: visible;
  padding: 1em;
`

const Body = ({ children }) => (
  <Card shadow={1} style={cardStyle}>
    <Content>{children}</Content>
  </Card>
)

export default Body



// WEBPACK FOOTER //
// ./src/Body.js